var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "el-button el-button--primary el-button--mini",
      class: "is-disabled",
      staticStyle: {
        display: "inline-block",
        width: "100%",
        "text-align": "center"
      }
    },
    [_vm._v("……")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }